/**
 * Ryan O'Dowd
 * 2022-04-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  const leftAndRightButtons = {
    display: 'flex',
    flexDirection: 'row',
    gap: globalScale * 10, // @TODO: does this match other dialogs?
  };

  return {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    titleWrapper: {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    titleText: { // @TODO: combine with Dialog.Title styles
      color: colors.dialogText,
      fontSize: globalScale * 22,
      fontFamily: fonts.primaryBold,
    },
    rightActions: {
      ...leftAndRightButtons,
      gap: 0,
    },
    bookName: {
      flex: 1,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    bookMetadata: {
      display: 'flex',
      fontSize: globalScale * 12,
      color: colors.white,
      opacity: 0.85,
    },
    rightData: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    innerContainer: {
      flexGrow: 1,
      paddingHorizontal: 16, // @TODO: i think typical is 32...should 16 be standard instead of just this dialog?
    },
    rowWrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    accordionInner: {
      flex: 1,
    },
    chapterActions: {
      alignItems: 'flex-start',
    },
    backToChaptersWrapper: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignSelf: 'flex-start',
      marginHorizontal: 4,
    },
    backIcon: {
      fontSize: 18,
      color: colors.white,
    },
    backText: {
      fontSize: 16,
      color: colors.white,
    },
    listItemContainer: {
      paddingLeft: 0,
      marginLeft: 0,
      paddingRight: 0,
      marginRight: 0,
    },
    flatList: {
      flexGrow: 1,
      gap: 4,
      paddingBottom: 4,
    },
    emptyText: {
      color: colors.dialogText,
    },
    selectedMenuItem: {
      fontFamily: fonts.primaryBold,
    },
    spacer: {
      flexGrow: 1,
    },
  };
};

export default getStyles;
